<div class="account-form-wrapper">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  @if (formConfig) {
    <app-dynamic-form
      #dynamicForm
      [config]="formConfig"
      [initialValues]="initialValues"
      [disabled]="isLoading"
      [mode]="isDialogMode ? 'popup' : 'page'"
      (formSubmit)="handleFormSubmit($event)"
      (formCancel)="handleFormCancel()"
      (formChange)="handleFormStateChange($event)"
    >
    </app-dynamic-form>
  }
</div>
